const USER_LOCALE_KEY = "user_locale";

export const getUserLocale = () => {
  return localStorage.getItem(USER_LOCALE_KEY) ?? "hi";
};

export const setUserLocale = (code) => {
  localStorage.setItem(USER_LOCALE_KEY, code);
};
